module.exports = __webpack_public_path__ + "img/rule_decoration_2.74c9d586.png";